import { render, staticRenderFns } from "./naklodnoyNew.vue?vue&type=template&id=58fb9b0a&scoped=true&"
import script from "./naklodnoyNew.vue?vue&type=script&lang=js&"
export * from "./naklodnoyNew.vue?vue&type=script&lang=js&"
import style0 from "./naklodnoyNew.vue?vue&type=style&index=0&id=58fb9b0a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fb9b0a",
  null
  
)

export default component.exports